import { ValidationTypes } from '../enums/ValidationTypes';
import { store } from '../store/Store';

const validationErrors = {
	required: 'This field is required',
	email: 'Invalid email address',
	name: 'Invalid name',
	number: 'Enter numbers only',
	password: 'At least 6 characters',
	username: 'Lowercase letters and numbers only',
};

const validate = (validations: [], value: any) =>
	validations
		?.filter(validation => {
			if (!value && validation !== 'required') return false;

			switch (validation) {
				case ValidationTypes.required:
					return !required(value);
				case ValidationTypes.email:
					return !email(value);
				case ValidationTypes.name:
					return !name(value);
				case ValidationTypes.username:
					return !username(value);
				case ValidationTypes.number:
					return !number(value);
				case ValidationTypes.password:
					return !password(value);
				default:
					return false;
			}
		})
		.map((error: string) => validationErrors[error]);

/** required */
const required = (value: any) => {
	const regex = /\s/g;
	return value?.replace(regex, '') !== '';
};

/** email */
export const email = (value: any) => {
	const regex =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return regex.test(value);
};

/** name */
const name = (value: any) => {
	const regex = /^[a-zA-Z (),@'/-]+$/;
	return regex.test(value);
};
// /[\w\(\),@'\/-]/g;

/** username */
const username = (value: any) => {
	const regex = /^[a-z0-9_.-]*$/;
	return regex.test(value);
};
// /[\w\(\),@'\/-]/g;

/** number */
const number = (value: any) => {
	const regex = /^\d+$/;
	return regex.test(value);
};

/** password */
const password = (value: any) => value.length >= 6;

export default validate;

export const checkHasErrors = (form, fields) => {
	const { forms } = store.getState();
	const formData = forms?.[form];

	const formErrors = fields
		?.map(field => formData?.errors?.[field]?.length)
		.filter(item => item !== 0);

	const errors = fields
		?.map(field => {
			return {
				error: validate(formData?.validations?.[field], formData?.values?.[field]),
			};
		})
		.map(item => (item?.error?.length > 0 ? true : false))
		.filter(error => error !== false).length;

	return errors > 0 || formErrors?.length > 0;
};
